import { Container, AppBar, Toolbar, Typography, IconButton, Card, CardHeader, Divider, Box } from '@mui/material';
import { ArrowBackOutlined, CardMembershipOutlined, PaymentOutlined, PaymentsOutlined, PixOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { toReal, createNewTheme, descriptografar, getBandeira } from '../functions/utils';
import * as React from 'react';

import LinkIcon from '@mui/icons-material/Link';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingComponent from '../components/LoadingComponent';
import Snackbar from '@mui/material/Snackbar';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';
import { SpacerGustio } from '../components/DesignSystem/SpacerGustio';
import { ButtonGustio } from '../components/DesignSystem/ButtonGustio';

function Pagamentos() {

  const state = useLocation().state;
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const page = state ? state.page : 'home';
  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [selectedCard, setSelectedCard] = useState(null);
  const [buttonEnabled, setButtonEnabled] = useState(true);
  const [formasPagamento, setFormasPagamento] = useState([]);
  const [formasPagamentoApp, setFormasPagamentoApp] = useState([]);
  const [valorTotalCarrinho, setValorTotalCarrinho] = useState("");
  const [valorLevar, setValorLevar] = useState("0,00");
  const [textButton, setTextButton] = useState("Continuar sem troco");
  const [troco, setTroco] = useState("");
  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/enderecos", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
  };

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const handleModalTroco = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    selectedCard ? setButtonEnabled(false) : setButtonEnabled(true)
    setOpen(false);
  };

  const handlePagamentos = (isTroco) => {
    if (isTroco) {
      localStorage.setItem('fmP', selectedCard);
      localStorage.setItem('sT', troco);
      navigate("/finalizar", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
      return
    }
    if (selectedCard === "dinheiro") {
      handleModalTroco()
      parseFloat(valorLevar.replaceAll(".", "").replaceAll(",", '.')) < 0 ? setButtonEnabled(true) : setButtonEnabled(false)
    } else {
      let cartaoSelecionado
      selectedCard.ID_forma_pagamento ? cartaoSelecionado = JSON.stringify(selectedCard) : cartaoSelecionado = selectedCard
      localStorage.setItem('fmP', cartaoSelecionado);
      localStorage.removeItem('sT');
      navigate("/finalizar", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
    }
  };

  const handleCardClick = (cardId) => {
    setSelectedCard(cardId);
    setButtonEnabled(false)
  };

  const getValorTotal = () => {
    let currentCarrinho = localStorage.getItem('crU');
    if (currentCarrinho) {
      currentCarrinho = JSON.parse(atob(currentCarrinho))
      let valorTotal = 0
      for (const produto of currentCarrinho) {
        valorTotal += parseFloat(produto.valorTotal.replaceAll(".", "").replaceAll(",", '.'))
      }
      let bloquearCarrinho = localStorage.getItem('bCrt');
      if (valorTotal === 0 && !bloquearCarrinho && localStorage.getItem("vPt")) {
        localStorage.removeItem('crU');
        navigate("/", { replace: true, state: { page: page } })
      }
      if (valorTotal === 0) {
        localStorage.setItem('fmP', "Combinar");
        localStorage.removeItem('sT');
        navigate("/finalizar", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
      }
      const taxa = localStorage.getItem('txE');
      const entrega = localStorage.getItem('tE');
      if (taxa && parseFloat(taxa.replaceAll(",", ".")) > 0 && entrega && entrega === "0") {
        setValorTotalCarrinho(toReal(valorTotal + parseFloat(taxa.replaceAll(".", "").replaceAll(",", '.'))))
        return
      }
      setValorTotalCarrinho(toReal(valorTotal))
    }
  }

  useEffect(() => {
    handleOpenLoading();

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store-${localStorage.getItem("Md")}.png?${new Date().getTime()}`;

    if (colorPrimary) {
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }

    console.log(localStorage.getItem("pGap"))
    if (localStorage.getItem("BTMd") === "A" && localStorage.getItem("pGap") === "true") {
      getFormasPagamento();
    }
    getInfos();
    getValorTotal();
    const pagamento = localStorage.getItem('fmP');
    setSelectedCard(pagamento);
    if (pagamento) {
      setButtonEnabled(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFormasPagamento = () => {
    const urlBase = localStorage.getItem('UBs');
    const idusuarios = localStorage.getItem('iUsr');
    axios.get(`${urlBase}/formas-pagamento-usr.php?idusuarios=${idusuarios}`)
      .then(response => {
        if (response.data) {
          setFormasPagamentoApp(response.data);
          handleCloseLoading();
          return;
        }
        setFormasPagamentoApp([]);
        handleCloseLoading();
      })
      .catch(error => console.log("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const handleTroco = (event) => {
    setTroco(event.target.value);
    const trocoLevar = parseFloat(event.target.value.replaceAll(".", "").replaceAll(",", ".")) - parseFloat(valorTotalCarrinho.replaceAll(".", "").replaceAll(",", "."))
    isNaN(trocoLevar) ? setValorLevar("0,00") : setValorLevar(toReal(trocoLevar))
    trocoLevar < 0 ? setButtonEnabled(true) : setButtonEnabled(false)

    event.target.value ? setTextButton("Continuar") : setTextButton("Continuar sem troco")
  };

  const getInfos = () => {
    // const mainId = localStorage.getItem('Md');
    const urlBase = localStorage.getItem('UBs');
    axios.post(`${urlBase}/formas-pagamento.php`, {
      idestabelecimentos: localStorage.getItem("Md")
    })
      .then(response => {
        setFormasPagamento(response.data[0]);
        handleCloseLoading();
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const returnFormas = (formas) => {
    if (!formas.formas_pagamento) {
      return
    }
    const pagamentosArray = formas.formas_pagamento.split("--");
    const creditodebito = pagamentosArray[1].split(",")
    const vrva = pagamentosArray[2].split(",")
    if (pagamentosArray[3]) {
      localStorage.setItem('cvP', pagamentosArray[3]);
    }

    return <>
      {pagamentosArray[3] && (
        <>
          <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%", border: selectedCard === 'pix' ? `2px solid rgba(${colorPrimary})` : '1px solid #DCDBDB' }} onClick={() => handleCardClick('pix')}>
            <CardHeader
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              avatar={
                <PixOutlined style={{ color: "#464545" }} />
              }
              title="PIX"
              titleTypographyProps={{ fontSize: "14px", fontWeight: "600", color: "#1B1B1B" }}
            />
          </Card>
          <SpacerGustio height={8} />
        </>
      )}
      {pagamentosArray[4] === "dinheiro" && (
        <>
          <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%", border: selectedCard === 'dinheiro' ? `2px solid rgba(${colorPrimary})` : '1px solid #DCDBDB' }} onClick={() => handleCardClick('dinheiro')}>
            <CardHeader
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              avatar={
                <PaymentsOutlined style={{ color: "#464545" }} />
              }
              title="DINHEIRO"
              titleTypographyProps={{ fontSize: "14px", fontWeight: "600", color: "#1B1B1B" }}
            />
          </Card>
          <SpacerGustio height={8} />
        </>
      )}

      {pagamentosArray[5] === "link" && (
        <>
          <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%", border: selectedCard === 'link de pagamento' ? `2px solid rgba(${colorPrimary})` : '1px solid #DCDBDB' }} onClick={() => handleCardClick('link de pagamento')}>
            <CardHeader
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              avatar={
                <LinkIcon style={{ color: "#464545" }} />
              }
              title="LINK DE PAGAMENTO"
              titleTypographyProps={{ fontSize: "14px", fontWeight: "600", color: "#1B1B1B" }}
            />
          </Card>
          <SpacerGustio height={8} />
        </>
      )}

      {creditodebito[0] && (
        <>
          {creditodebito.map((cartoes) => (
            <>
              <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%", border: selectedCard === cartoes ? `2px solid rgba(${colorPrimary})` : '1px solid #DCDBDB' }} onClick={() => handleCardClick(cartoes)}>
                <CardHeader
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  avatar={
                    <PaymentOutlined style={{ color: "#464545" }} />
                  }
                  title={cartoes.toUpperCase()}
                  titleTypographyProps={{ fontSize: "14px", fontWeight: "600", color: "#1B1B1B" }}
                />
              </Card>
              <SpacerGustio height={8} />
            </>
          ))}
        </>
      )}

      {vrva[0] && (
        <>
          {vrva.map((vales) => (
            <>
              <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%", border: selectedCard === vales ? `2px solid rgba(${colorPrimary})` : '1px solid #DCDBDB' }} onClick={() => handleCardClick(vales)}>
                <CardHeader
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  avatar={
                    <CardMembershipOutlined style={{ color: "#464545" }} />
                  }
                  title={vales.toUpperCase()}
                  titleTypographyProps={{ fontSize: "14px", fontWeight: "600", color: "#1B1B1B" }}
                />
              </Card>
              <SpacerGustio height={8} />
            </>
          ))}
        </>
      )}
    </>
  }



  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>
        <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
          <Toolbar>
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#FFF" }} onClick={handleBack}>
              <ArrowBackOutlined />
            </IconButton>
            Forma de pagamento
          </Toolbar>
        </AppBar>

        <LoadingComponent open={loading} />

        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleClose}
          message={msgSnack}
        />

        <SpacerGustio height={70} />

        <Dialog
          open={open}
          onClose={handleCloseDialog}
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              handlePagamentos(true)
              handleCloseDialog();
            },
          }}
        >
          <DialogTitle>Precisa de troco?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Digite o valor em dinheiro para levar o valor exato do troco:
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="Valor"
              value={troco}
              onChange={handleTroco}
              fullWidth
            />
          </DialogContent>
          <DialogContentText style={{ fontSize: "12px", paddingLeft: "25px", marginTop: "-16px" }}>
            Valor total: R$ {valorTotalCarrinho}<br />
            Valor troco: R$ {valorLevar}
          </DialogContentText>
          <DialogActions>
            <Box sx={{ p: "12px", display: "flex" }}>
              <ButtonGustio fullWidth={false} style={{ margin: 2 }} onClick={handleCloseDialog}>Voltar</ButtonGustio>
              <SpacerGustio width={10} />
              <ButtonGustio fullWidth={false} style={{ margin: 2 }} type="submit" disabled={buttonEnabled}>{textButton}</ButtonGustio>
            </Box>
          </DialogActions>
        </Dialog>

        {localStorage.getItem("BTMd") === "A" && localStorage.getItem("pGap") === "true" && formasPagamentoApp && formasPagamentoApp.length > 0 &&
          <>
            <SpacerGustio height={12} />
            <Typography style={{ color: "#1B1B1B", fontSize: "16px", fontWeight: "bold" }}>
              Pagar pelo APP
            </Typography>

            <SpacerGustio height={12} />

            {formasPagamentoApp.map((cartoes) => (
              <>
                <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%", border: selectedCard === cartoes ? `2px solid rgba(${colorPrimary})` : '1px solid #DCDBDB' }} onClick={() => handleCardClick(cartoes)}>
                  <CardHeader
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    avatar={<img alt="bandeira" src={`${localStorage.getItem('UBs').replaceAll("/api", "")}/imagens/${getBandeira(cartoes.NR_CT)}.png`} style={{ width: 40 }} />}
                    title={<Typography style={{ fontSize: 11, color: "#777" }}>{descriptografar(cartoes.NR_CT)}<br /><b style={{ fontSize: 14, color: "#222" }}>{cartoes.NM_USR}</b></Typography>}
                    titleTypographyProps={{ fontSize: "14px", fontWeight: "600", color: "#1B1B1B" }}
                  />
                </Card>
                <SpacerGustio height={8} />

              </>
            ))}

            <SpacerGustio height={12} />

            <Divider />
          </>
        }
        <SpacerGustio height={12} />
        <Typography style={{ color: "#1B1B1B", fontSize: "16px", fontWeight: "bold" }}>
          Selecione um meio de pagamento para finalizar o seu pedido.
        </Typography>

        <SpacerGustio height={12} />

        {returnFormas(formasPagamento)}

        <Box style={{ position: "fixed", bottom: "0", right: "0", left: "0", backgroundColor: "white", padding: "16px 16px 16px 16px", borderTop: "solid 1px" }}>
          <ButtonGustio disabled={buttonEnabled} onClick={() => handlePagamentos(false)}> Continuar </ButtonGustio>
        </Box>
        <SpacerGustio height={100} />

      </Container>
    </ThemeProvider >
  );
}

export default Pagamentos;